import * as actions from "./notificationsTouchAllPutActions.js";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.NOTIFICATIONS_TOUCH_ALL_PUT_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: null,
  }),

  [actions.NOTIFICATIONS_TOUCH_ALL_PUT_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
  }),

  [actions.NOTIFICATIONS_TOUCH_ALL_PUT_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loading: false,
  loaded: false,
  error: null,
  data: null,
};

export default function notificationsTouchAllPutReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
